import { render } from "./PuntoCyanStreamlined.vue?vue&type=template&id=b8eb0d82&scoped=true"
import script from "./PuntoCyanStreamlined.vue?vue&type=script&lang=ts"
export * from "./PuntoCyanStreamlined.vue?vue&type=script&lang=ts"

import "./PuntoCyanStreamlined.vue?vue&type=style&index=0&id=b8eb0d82&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b8eb0d82"

export default script